import React from "react";

type ApplyLabelProps = {
  text?: string;
  appliedText?: string;
  applied?: boolean;
};

export const ApplyLabel = ({ applied, appliedText, text }: ApplyLabelProps) =>
  applied ? <>{appliedText}</> : <>{text}</>;
